import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type LocaleCode = 'en' | 'tr' | 'es' | 'fr' | 'de' | 'ja';

export const LOCALE_OPTIONS: { code: LocaleCode; label: string }[] = [
  { code: 'en', label: 'English' },
  { code: 'tr', label: 'Türkçe' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'ja', label: '日本語' },
];

function applyDocumentLocale(locale: LocaleCode): void {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
  }
}

interface LocaleState {
  locale: LocaleCode;
  setLocale: (locale: LocaleCode) => void;
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: 'en',
      setLocale: (locale) => {
        applyDocumentLocale(locale);
        set({ locale });
      },
    }),
    {
      name: 'prototype-locale',
      partialize: (state) => ({ locale: state.locale }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          applyDocumentLocale(state.locale);
        }
      },
    }
  )
);
